import { useDispatch, useSelector } from 'react-redux';
import featureSlice from '../slices/featureSlice';
import { featureApi } from '../../areas/settings/feature-flags/api/featureApi';
import { useEffect } from 'react';

const useFeatures = () => {
  const features = useSelector(featureSlice.selectors.getFeatures);
  const isInitialized = useSelector(featureSlice.selectors.isInitialized);

  const dispatch = useDispatch();

  // Features are now automatically dispatched to the store by the featureApi
  const { data } = featureApi.useApiPortalV1FeaturesListQuery(undefined, {
    skip: false,
  });

  useEffect(() => {
    if (data) {
      dispatch(featureSlice.actions.setFeatures(data));
    }
  }, [data, dispatch]);

  return {
    features,
    initialized: isInitialized,
    isFeatureEnabled: (name: string) =>
      features.some(feature => feature.name === name && feature.enabled),
  };
};

export default useFeatures;
